<template>
  <div>
    <BaseModal :config="InvestmentModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">       
        <form ref="refInvestmentValuationForm" id="InvestmentValuationForm" action>
          <!-- <div
            id="error"
            class="alert alert-danger"
            role="alert"
            v-if="displayErrors"
            v-show="errors.items.length"
          >
            <span v-show="errors.has('InvestmentId')" class="alert-danger">
              {{ errors.first('InvestmentId') }}
              <br>
            </span>
            <span v-show="errors.has('InvestmentName')" class="alert-danger">
              {{ errors.first('InvestmentName') }}
              <br>
            </span>
          </div> -->
          <div id="pageErrors" class="alert alert-danger"  v-if="pageErrors.length>0">
            <p >
            <b >Please correct the following error(s):</b>
            <ul >
            <li  v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
            </p>
          </div>
          <div
            id="Customerror"
            class="alert alert-danger"
            role="alert"
            v-show="customerrors.length && !errors.items.length"
          >
            <span v-show="customerrors.length" class="alert-danger">
             <b>Please correct the following error(s):</b>
            <ul>
            <li v-for="error in customerrors" :key=error>{{ error }}</li>
            </ul>
            </span>
          </div>

          
 					<div class="form-row">
            <div class="form-group col-md-6">
              <label>Investment ID</label>              
              <input
                type="text"
                id="txtInvestmentId"
                name="InvestmentId"                
                v-model="InvestmentInfo.parent.InvestmentID"
                class="form-control"
                placeholder="Investment Id"
                disabled
              >
              
            </div>
						<div class="form-group col-md-6">
              <label >Investment Name</label>                          
              <input
                type="text"
                id="txtInvestmentName"
                name="InvestmentName"                
                v-model="InvestmentInfo.parent.Title"
                class="form-control"
                placeholder="Investment Name"
                disabled
              >                        
          </div>
          </div>          
          
          <br/>
          <div class="form-row">
            <div class="form-group col-md-12">
              <!-- <label>Statement Order</label> -->
             <BaseGrid
              :mode="'incell'"
              :config="InvestmentValuationFormConfig" 
              :data="InvestmentInfo.children.InvestmentValuation"
              :dropdownOptions="IVDropDowns"
              @DeleteItem="InvestmentDeleteitem"
            ></BaseGrid>
              
            </div>						
          </div>

							
        	
        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
import BaseModal from "@/components/base/BaseModal.vue";
import apiUtil from "@/services/apiUtil.js";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import moment from "moment";
import funcUtil from "@/services/funcUtil.js";
import InvestmentValuationFormConfig from "./InvestmentValuationFormConfig.js";
import BaseGrid from "@/components/base/BaseGrid.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "InvestmentValuationForm",
  props: {
    InvestmentInfo: {},
    InvestmentModalLabel: {},
    // partnerAutoCompleteDisplayedValue: {},
    // programAutoCompleteDisplayedValue: {},
    // ProgramUnitClassJsonData: {}
  },
  mixins: [apiUtil, funcUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter","getLocalInputControls"]),
    
    // UnitClassOptions() {
    //   //console.log("before");
    //   var ddlValue = [];
    //   this.ProgramUnitClassJsonData.option.forEach(element => {
    //     ddlValue.push(element.UnitClass);
    //   });
    //   // this.ProgramUnitClassJsonData.forEach(function(key) {
    //   //   ddlValue.push(key);
    //   // });
    //   return ddlValue;
    // },
     
  },
  data: function() {
    return {
      BaseModelInvestment: BaseModelInvestment,
      BaseModelInvestmentValuation:BaseModelInvestmentValuation,
      BaseModelProgram: BaseModelProgram,
      BaseModelPartner: BaseModelPartner,   
      InvestmentValuationFormConfig:InvestmentValuationFormConfig,  
      
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        TaxYear: { model: "", dataSource: [] }, 
        TaxQuarter: { model: "", dataSource: [] },  
        InvestmentGroup: { model: "", dataSource: [] },      
      },
      customerrors:[],
      IVDeleteItemsArray:[],
      IVDropDowns:{},
      InvestmentGroupOptions:[],
      pageErrors : [],
      // InvestmentAutoCompleteSource: [],
      // bInvestmentValid:true,
      // ProgramUnitClassJsonData:[],
      // InvestmentAutoCompleteDisplayedValue:"",
      // partnerAutoCompleteDisplayedValue:"",
    };
  },
  methods: {
    ...mapActions("postModule",["CreateAllItems","deleteAllItem","UpdateAllItems","CreateJoinedItems"]),

    // getInvestmentAutoCompleteData() {

    //   this.InvestmentAutoCompleteSource = this.withFilter(BaseModelInvestment.list);
    // },
    //  onInvestmentAutoCompleteSelect(e) {
    //   this.bInvestmentValid=true;
    //   this.autocompleteValue = e.dataItem.Id;

    //   this.InvestmentInfo.parent.Id = e.dataItem.Id;
    //   this.InvestmentInfo.parent.Title = e.dataItem.Title;    
    //   this.InvestmentInfo.parent.InvestmentID = e.dataItem.InvestmentID; 
      
    
    // },
    //  onInvestmentOpen(){
    //   this.bInvestmentValid=false;
    // },
    // onInvestmentClose(){
    //   if (!this.bInvestmentValid) {
    //     this.InvestmentInfo.parent.Id = null;
    //     this.InvestmentInfo.parent.Title = null;
    //     this.InvestmentInfo.parent.InvestmentID = null;
    //   }
    // },
    
    Validate(){
            const self=this;
            self.pageErrors = [];
            let form=self.InvestmentInfo.parent;
            
        //Investment Valuation Grid Validation
            let IVGrid=self.InvestmentInfo.children.InvestmentValuation;
            let TaxYearQuarterArray = [];
            let bIVTable = false, bIVTaxYear = false, bIVTaxQuarter = false, bDuplicateYearQuarter= false, bIVProjVal = false, bIVCurrVal = false;
              if (IVGrid.length>0) {
                IVGrid.some(IVGridItem => {
                  if(!IVGridItem.TaxYear){
                    if(!bIVTable){
                    self.pageErrors.push("Investment Valuation Table:");
                    bIVTable = true;
                    }
                    if(!bIVTaxYear){
                    self.pageErrors.push("Tax Year is required");
                    bIVTaxYear = true;
                    }
                  }
                  if(!IVGridItem.TaxQuarter){
                    if(!bIVTable){
                    self.pageErrors.push("Investment Valuation Table:");
                    bIVTable = true;
                    }
                    if(!bIVTaxQuarter){
                    self.pageErrors.push("Tax Quarter is required");
                    bIVTaxQuarter = true;
                    }
                  }
                  if(bIVTaxYear && bIVTaxQuarter){
                    return;
                  }

                  //if both the Tax Year and Tax Quarter is not empty then check for duplicate
                  let TaxYearQuarter = IVGridItem.TaxYear + IVGridItem.TaxQuarter;
                  if(TaxYearQuarterArray.indexOf(TaxYearQuarter)>=0){
                    if(!bIVTable){
                    self.pageErrors.push("Investment Valuation Table:");
                    bIVTable = true;
                    }
                    if(!bDuplicateYearQuarter){
                    self.pageErrors.push(`Combination of Tax Year and Tax Quarter (${IVGridItem.TaxYear} & ${IVGridItem.TaxQuarter})  should be unique `);
                    bDuplicateYearQuarter = true;
                    }

                  }else{
                    TaxYearQuarterArray.push(TaxYearQuarter);
                  }
                });
                
              }      

        //Validation failed or success
            return self.pageErrors.length>0 ? false:true
    },

    isDataSourceDirty: function(DataSource) {
            let DataSourceDirty = false;
            DataSourceDirty = DataSource._data.some(obj =>{                
                if(obj.dirty === true){
                    return true;
                }
            });
            return DataSourceDirty;
    },
    InvestmentDeleteitem(e){      
        e.preventDefault();
        var gview = window.$("#InvestmentValuationFormGrid").data("kendoGrid");
        // if(this.isDataSourceDirty(gview.dataSource)){
        //     this._AlertPopup("Please do save or cancel changes on the Investment Valuation before clicking on the Delete!","warning");
        // }
        // else{
            const message ="Are you sure you want to delete this record?";
            this._ConfirmationPopup(message,"DELETE").then((result) => {
                if(result.value) {
                                        
                    var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                    if(dataItem.Id != 0 && dataItem.Id != null && dataItem.Id != undefined)
                    {
                      this.IVDeleteItemsArray.push({"Id": dataItem.Id});
                    }                        
                    var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");                        
                    gview.removeRow(row);
                    
                    
                    // //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
                    // //alert(JSON.stringify(dataItem));
                    // if(dataItem.Id != 0 && dataItem.Id != null && dataItem.Id != undefined)
                    // {
                    //     this.IVDeleteItemsArray.push({"Id": dataItem.Id});
                    //     let objIndex = this.InvestmentInfo.children.InvestmentValuation.findIndex(
                    //         obj => obj.Id == dataItem.Id
                    //     );
                    //     if(objIndex >=0)
                    //     {
                    //         this.InvestmentInfo.children.InvestmentValuation.splice(objIndex, 1);
                    //     }
                    //     var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
                    //     // gview.editable.confirmation =false;
                    //     // window.confirm = function() { return true; };
                    //     gview.removeRow(row);
                    // } 
                    // else{                                                
                    //     var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
                    //     // gview.editable.confirmation =false;
                    //     // window.confirm = function() { return true; };
                    //     gview.removeRow(row);
                    //     let objIndex = this.InvestmentInfo.children.InvestmentValuation.findIndex(
                    //         obj => obj.TaxYear == dataItem.TaxYear && obj.TaxQuarter == dataItem.TaxQuarter && obj.ProjectedValue == dataItem.ProjectedValue && obj.CurrentValue == dataItem.CurrentValue
                    //     );
                    //     if(objIndex >=0)
                    //     {
                    //         this.InvestmentInfo.children.InvestmentValuation.splice(objIndex, 1);
                    //     }                        
                    // }                   
                                   
                }            
            });
        // }
    },
    
     getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
        console.log(response);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });

        //Filling the Drop down options for the Grid DropDown Columns
        // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
        this.IVDropDowns.TaxYear=this.dropdowns.TaxYear.dataSource;
        this.IVDropDowns.TaxQuarter=this.dropdowns.TaxQuarter.dataSource;  
        this.InvestmentGroupOptions = this.dropdowns.InvestmentGroup.dataSource;      
      // });
    },
     GetCurrentGridData(gridId) {
            const grid = $("#" + gridId).data("kendoGrid");
            let gridArray = [];
            var gridData = grid.dataSource.data();
            for (let i = 0; i < gridData.length; i++) {
                let element = gridData[i];
                gridArray.push(element)
            }
            return gridArray;
            //console.log(this.ProgramInfoTemplate)
     },
    
    saveChanges: async function() {
      let self=this;
      this.displayErrors = true;
      const gview = window.$("#InvestmentValuationFormGrid").data("kendoGrid");
      //Read current data from the Grid
      this.InvestmentInfo.children.InvestmentValuation =  this.GetCurrentGridData("InvestmentValuationFormGrid");
      // if(this.isDataSourceDirty(gview.dataSource)){
      //     this._AlertPopup("Please do save or cancel changes on the Investment Valuation before clicking on the Save!","warning");
      // }
      // else{        
        // this.$validator.validate().then(result => {
        if (self.Validate()) {
          // if (this.InvestmentModalLabel.modalAddorEdit == "add") {
          //   // Add Popup                  
          //   console.log(JSON.stringify(this.InvestmentInfo));            
          //   let addFormValues = this.InvestmentInfo;
            
          //   // US #1180 : Investment ID
          //   const result = this.withFilter(self.BaseModelInvestment.list, "");

          //   if (result.length <= 0) {
          //     addFormValues.parent.InvestmentID = 500001;
          //   } else {
          //     //let lastElement = _.last(result);
          //     addFormValues.parent.InvestmentID = self._getIncrementalID(result,"InvestmentID");
          //   }

          //   let joinedItems = { "joinedObject" : {
					// 	    parentConfig: BaseModelInvestment, 				
          //       childConfigs: [BaseModelInvestmentValuation]                            
          //   }, "createData": addFormValues,"ParentKey": "InvestmentId" }

          //   let loader = this.$loading.show();
          //   this.CreateJoinedItems(joinedItems).then((response) => {
          //   //refresh the grid data only after the update gets completed
          //   // console.log(response);
          //       // $("#programGrid").data().kendoGrid.dataSource.read();
          //   //Having a timeout of 100 ms in order to avoid error in reading data after update
          //       // setTimeout(function(){
          //         loader.hide();
          //           self.$emit("SaveComplete");
          //           self._AlertPopup("Data Saved Successfully!","success");
          //           self.resetFields();
          //       // }, 100);
          //   });
          // } else {
            // Edit Popup             
            console.log(JSON.stringify(this.InvestmentInfo));
            var editForm = this.InvestmentInfo.parent;
            var editFormIV = this.InvestmentInfo.children.InvestmentValuation; 

            var editFormArray = [];
            editFormArray.push(editForm);      
            
            //let loader = this.$loading.show();   
            this._APICrudPopup("APICrudpopup");
            
            if(this.IVDeleteItemsArray.length>0){
            //Deleted unit class items in edit form
            var deletedobject = {                             
                  InvestmentValuation: {config: BaseModelInvestmentValuation, deleteData: this.IVDeleteItemsArray}
            };

            let deleteResponse = await this.deleteAllItem(deletedobject)
            // this.deleteAllItem(deletedobject).then(res => res);
            //this._deleteAllItems(deletedobject);
            }

            //added Investment Valuation items in edit form
            var addedIVArray = [];
            addedIVArray=this.getaddeditems(editFormIV);
            addedIVArray.forEach(element => {
                element.InvestmentId =  editForm.Id;
            });
         
            if(addedIVArray.length>0){
            //using Create All method for newly added unit class and Vesting schedule info
            var createdobject = {                             
                  InvestmentValuation: {config: BaseModelInvestmentValuation, createData: addedIVArray}                  
            };
            let createResponse = await this.CreateAllItems(createdobject);
            // this.CreateAllItems(createdobject).then(res => res);
            //this._createAllItems(createdobject);
            }

            

            //Remove added items from update JSON
            editFormIV = this.removeAddedItemsforUpdate(editFormIV);

            //using Update All method
            var updateobject = {
                  // Investment: {config: BaseModelInvestment, updateData: editFormArray},
                  InvestmentValuation: {config: BaseModelInvestmentValuation, updateData: editFormIV}
            };
            // this._updateAllItems(updateobject).then( (response) => {
            this.UpdateAllItems(updateobject).then(res => {

                //refresh the grid data only after the update gets completed
                // console.log(response);
                    // $("#programGrid").data().kendoGrid.dataSource.read();
                //Having a timeout of 100 ms in order to avoid error in reading data after update
                    // setTimeout(function(){
                      //loader.hide();
                        self.$emit("SaveComplete");
                        self._AlertPopup("Data Saved Successfully!","success");
                        self.resetFields();
                    // }, 100);                                 
                    
            }).catch(error=>{
              self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                    //loader.hide();
            })
            
          // }
          // alert("Data Saved Successfully!");  
            //  self._AlertPopup("Data Saved Successfully!","success");
            //   $("#BaseModal").modal("toggle");
            //   self.resetFields();
            $("#BaseModal").modal("toggle");
        }
        else{
          // $('#pageErrors').focus();
          let basemodal = $("#BaseModal");
          $("input:text:visible:first", basemodal).focus();
        }
        // });
      // }      
    },
    resetFields: function() {
      // let self=this;
      //  this.$refs.refProgramForm.$refs.ProgramForm.reset();
      this.displayErrors = false;
      this.errors.clear();
      this.customerrors=[];
    },  
     removeAddedItemsforUpdate:function(objdata){
      let filteredData= objdata.filter(function(e) {
          return (
                  e["Id"] != 0 && e["Id"] != null && e["Id"] != undefined
          )
			});
			return filteredData;	
    }, 
    getaddeditems:function(objdata){
      let filteredData= objdata.filter(function(e) {
        return (
            e["Id"] == 0 || e["Id"] == null || e["Id"] == undefined
        )
			});
			return filteredData;			
    }, 
  },
  mounted() {
     this.getInputControls();

    // alert(JSON.stringify(this.ProgramInfoFormConfig));
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });
    // this.getInvestmentAutoCompleteData();    

    // //For Displaying List on Focus
    // this.ShowAutoCompleteListOnFocus("SearchInvestment");
    
    // $("#dtInvestmentDate").on("change",this.InvestmentDateChanged);
  },
  components: {
    BaseModal,
    BaseGrid
  }
};
</script>
<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}

/* input[type="radio"]{
  width: 22px;
  margin-top: 4px;
}*/
/* .addButtonClass{
  /* margin-left:70%; 
} */
</style>
